// extracted by mini-css-extract-plugin
export default {"bolded":"style--bolded--e66c60","subHeader":"style--subHeader--662662"};